import RestService from '../services/rest';

async function getOverdueClients({
  page, limit, orderBy, search,
}) {
  let route = 'panel/overdueClients';

  if (page) route += `?page=${page}`;
  if (limit) route += `&limit=${limit}`;
  if (orderBy) route += `&orderBy=${orderBy}`;
  if (search) route += `&search=${search}`;

  return RestService.getAuthenticated(route);
}

export default {
  getOverdueClients,
};
